import { accessJsonAttr } from '../../utils/utils';
import { MgpCheckboxProps } from './MgpCheckbox.types';


export default function MgpFormCheckbox({
    id, 
    label, 
    required, 
    register, 
    errors = {}, 
    labelFontWeight, 
    labelColor, 
    inputSize,
    ...props }: MgpCheckboxProps)  {

    let labelClassName = "form-check-label text form-center";
    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
          labelClassName += " form-error";
        }
    }
    if(labelColor) {
        labelClassName += " " + labelColor;
    }
    if (labelFontWeight) {
        labelClassName += " fw-" + labelFontWeight;
    }

    let inputClassName = inputSize ? inputSize : "";
    return (
        <>
          <input 
            type="checkbox" 
            id={id} 
            {...register(id)} 
            {...props} 
            className={inputClassName}
          />
          <label className={labelClassName} htmlFor={id} >
            {label && (
                  <span >
                      {label}
                      {required && <span className='fushia'> (*)</span>}
                  </span>
            )}
          </label>
        </>
  )
}
